type EventCallback<T> = ((data: T, force?: boolean) => void) & {
  _id?: string;
};

export class MyEvent<T = unknown> {
  cbs: EventCallback<T>[];

  constructor() {
    this.cbs = [];
  }

  public addListener = (cb: EventCallback<T>) => {
    this.cbs.push(cb);
  };

  public removeListener = (cb: EventCallback<T>) => {
    let index = this.cbs.indexOf(cb);
    if (index === -1 && !!cb._id) {
      // not found by reference
      // try to find by _id
      index = this.cbs.findIndex((cbx) => cbx._id === cb._id);
    }
    if (index > -1) {
      this.cbs.splice(index, 1);
    }
  };

  public trigger = (data: T) => {
    this.cbs.forEach((cb) => cb(data));
  };
}
